/**
 * OVILIP Product Page & Tabs Functionality
 */
document.addEventListener('DOMContentLoaded', () => {
  // 1. Tab Switching
  function initTabs() {
    document.querySelectorAll('.ovilip-tab-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const nav = btn.closest('.ovilip-tabs-nav');
        const container = btn.closest('.ovilip-tabs-container');
        if (!nav || !container) return;

        const targetId = btn.getAttribute('data-tab-target');
        nav.querySelectorAll('.ovilip-tab-btn').forEach(b => b.classList.remove('active'));
        container.querySelectorAll('.ovilip-tab-pane').forEach(p => p.classList.remove('active'));

        btn.classList.add('active');
        const targetPane = document.getElementById(targetId);
        if (targetPane) {
          targetPane.classList.add('active');
        }
      });
    });
  }

  // 2. Countdown Timer
  function initCountdown() {
    const timerElements = document.querySelectorAll('.ovilip-countdown-timer');
    timerElements.forEach(timer => {
      // Start with 59 minutes and 47 seconds or calculate
      let totalSeconds = 3587; // 59m 47s

      function updateTimer() {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const pad = (n) => String(n).padStart(2, '0');
        timer.innerHTML = `<strong>${pad(hours)}h : ${pad(minutes)}m : ${pad(seconds)}s</strong>`;

        if (totalSeconds > 0) {
          totalSeconds--;
        } else {
          totalSeconds = 3600; // loop
        }
      }

      updateTimer();
      setInterval(updateTimer, 1000);
    });
  }

  // 3. BUY NOW button direct checkout
  function initBuyNow() {
    document.addEventListener('click', (e) => {
      const buyBtn = e.target.closest('.ovilip-buy-now-btn');
      if (!buyBtn) return;
      e.preventDefault();

      const form = buyBtn.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      const variantInput = form.querySelector('[name="id"]');
      const qtyInput = form.querySelector('[name="quantity"]');
      const variantId = variantInput ? variantInput.value : null;
      const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      if (!variantId) return;

      buyBtn.style.opacity = '0.6';
      buyBtn.style.pointerEvents = 'none';

      fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(() => {
        window.location.href = '/checkout';
      });
    });
  }

  // 4. Update variant selected labels on radio change
  function initVariantLabelUpdate() {
    document.querySelectorAll('.product-form__input--pill, .product-form__input').forEach(fieldset => {
      const labelSpan = fieldset.querySelector('[data-selected-value], .selected-value-text');
      if (!labelSpan) return;

      const radios = fieldset.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          if (radio.checked) {
            labelSpan.textContent = radio.value;
          }
        });
      });
    });
  }

  initTabs();
  initCountdown();
  initBuyNow();
  initVariantLabelUpdate();

  document.addEventListener('shopify:section:load', () => {
    initTabs();
    initCountdown();
    initVariantLabelUpdate();
  });
});
